import React from 'react';
import PropTypes from 'prop-types';
import CarouselImage from './CarouselImage';
import CarouselRender from './CarouselRender';
import { useCarouselNavigation } from './hooks/useCarouselNavigation';
import { getDisplayCountData } from '../../helpers';

const Carousel = props => {
  const { caption, imageIds, isCaptionDisplayed, VariantComponent, ...otherProps } = props;

  const navigationProps = useCarouselNavigation(props);

  if (!imageIds || !imageIds.length) return null;
  const shouldDisplayCaption = isCaptionDisplayed && caption;

  const { shouldDisplayCount, countMessage } = getDisplayCountData(
    navigationProps.showCount,
    imageIds
  );

  const ComponentToRender = VariantComponent || CarouselRender;

  return (
    <ComponentToRender
      caption={caption}
      imageIds={imageIds}
      CarouselImage={CarouselImage}
      shouldDisplayCaption={shouldDisplayCaption}
      shouldDisplayCount={shouldDisplayCount}
      countMessage={countMessage}
      {...navigationProps}
      {...otherProps}
    />
  );
};

Carousel.propTypes = {
  caption: PropTypes.string,
  imageIds: PropTypes.array,
  isCaptionDisplayed: PropTypes.bool,
  VariantComponent: PropTypes.func
};

Carousel.defaultProps = {
  VariantComponent: null,
  caption: '',
  imageIds: [],
  isCaptionDisplayed: false
};

export default Carousel;
